import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ClearFormatting = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.13674 14.038L4.67644 10.361H7.87663L8.91283 9.32971H5.06264L7.17479 3.61096H7.29361L9.18814 9.05572L10.0454 8.20258L7.76575 2.00159H6.75013L1.85889 14.038H3.13674ZM13.178 8.18867C12.9827 7.98511 12.6578 7.9833 12.4602 8.18466L10.0292 10.6628L11.6929 12.4383L14.1652 9.91809C14.3545 9.72518 14.3562 9.4168 14.1691 9.22179L13.178 8.18867ZM10.9919 13.1528L9.32826 11.3773L8.52668 12.1944C8.33744 12.3873 8.33572 12.6956 8.5228 12.8907L9.51395 13.9238C9.70923 14.1273 10.0341 14.1291 10.2317 13.9278L10.9919 13.1528ZM11.7464 7.48437C12.339 6.88027 13.3137 6.88571 13.8996 7.49637L14.8907 8.5295C15.452 9.11453 15.4468 10.0396 14.8791 10.6184L10.9455 14.6281C10.3529 15.2322 9.37818 15.2267 8.79234 14.6161L7.80119 13.5829C7.23993 12.9979 7.24509 12.0728 7.81283 11.4941L11.7464 7.48437Z"
        />
      </svg>
    )
  },
)

export default ClearFormatting
